/* eslint-disable ordered-imports/ordered-imports */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { buildCommerceEngine, CommerceEngine, CartItemWithMetadata, CartState, CartItem } from '@coveo/headless/commerce';

// import { CartLineModel, CartModel, ProductModel, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
// import { createRelay, Relay } from '@coveo/relay';
// import { Ec, ProductQuantity } from "@coveo/relay-event-types";

import { get } from "@insite/client-framework/Services/ApiService";
// import { CoveoProductModel } from "@NA/Types/CoveoModel";

const coveoTokenUrl = "/api/v2/coveotoken";

const getToken = async () => {
  const coveoTokenCookieValue = getCookieValue('coveoSearchToken');
  const coveoOrgIdCookieValue = getCookieValue('coveoOrgId');
  const coveoCommerceViewCookieValue = getCookieValue('commerceView');
  const coveoCountryCookieValue = getCookieValue('country');
  const coveoCurrencyCookieValue = getCookieValue('currency');
  const coveoLanguageCookieValue = getCookieValue('language');
  const coveoTrackingIdCookieValue = getCookieValue('trackingId');


  if (
    coveoTokenCookieValue === '' ||
    coveoOrgIdCookieValue === '' ||
    coveoCommerceViewCookieValue === '' ||
    coveoCountryCookieValue === '' ||
    coveoCurrencyCookieValue === '' ||
    coveoLanguageCookieValue === '' ||
    coveoTrackingIdCookieValue === ''
  ) {
    const response = await get<string>(`${coveoTokenUrl}`);
    const json = JSON.stringify(response);
    const jsonValue = JSON.parse(json);
    const token = jsonValue["token"];
    const coveoOrgId = jsonValue["coveoOrgId"];
    const commerceView = jsonValue["commerceView"];
    const country = jsonValue["country"];
    const currency = jsonValue["currency"];
    const language = jsonValue["language"];
    const trackingId = jsonValue["trackingId"]
    document.cookie = `commerceView=${commerceView}; max-age=${24 * 60 * 60 * .95};path=/`;
    document.cookie = `country=${country}; max-age=${24 * 60 * 60 * .95};path=/`;
    document.cookie = `currency=${currency}; max-age=${24 * 60 * 60 * .95};path=/`;
    document.cookie = `language=${language}; max-age=${24 * 60 * 60 * .95};path=/`;
    document.cookie = `coveoSearchToken=${token}; max-age=${24 * 60 * 60 * .95};path=/`;
    document.cookie = `coveoOrgId=${coveoOrgId}; max-age=${24 * 60 * 60 * .95};path=/`;
    document.cookie = `trackingId=${trackingId}; max-age=${24 * 60 * 60 * .95};path=/`;
    return jsonValue;
  }
  const obj = {
    token: coveoTokenCookieValue,
    coveoOrgId: coveoOrgIdCookieValue,
    commerceView: coveoCommerceViewCookieValue,
    country: coveoCountryCookieValue,
    currency: coveoCurrencyCookieValue,
    language: coveoLanguageCookieValue,
    trackingId: coveoTrackingIdCookieValue
  };
  const json = JSON.stringify(obj);
  const jsonValue = JSON.parse(json);
  return jsonValue;

};
// export function getCoveoTokenAndOrg() {
//     const coveoTokenCookieValue = getCookieValue('coveoSearchToken');
//     const coveoOrgIdCookieValue = getCookieValue('coveoOrgId');
//     const obj = { token: coveoTokenCookieValue, coveoOrgId: coveoOrgIdCookieValue };
//     const json = JSON.stringify(obj);
//     const jsonValue = JSON.parse(json);
//     return jsonValue;
// }
export function clearCoveoTokenAndOrg() {
  document.cookie = 'coveoSearchToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'coveoOrgId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'commerceView=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'country=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'currency=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'language=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'trackingId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}
export const getCommerceEngine = async (): Promise<CommerceEngine> => {
  const response = await getToken();
  // const token = jsonValue["token"];
  return _initCommerceEngine(response);
};

const _initCommerceEngine = (oAccessToken: any) => {
  // console.log('oAccessToken >>', oAccessToken);
  return buildCommerceEngine({
    configuration: {
      organizationId: oAccessToken.coveoOrgId,
      accessToken: oAccessToken.token,
      // organizationEndpoints: getOrganizationEndpoints(oAccessToken.coveoOrgId),
      renewAccessToken: getToken,
      context: {
        language: oAccessToken.language.split('-')[0],
        currency: oAccessToken.currency,
        country: oAccessToken.country,
        view: {
          url: oAccessToken.commerceView,
          // url: 'https://dev.adiglobaldistabution.us',
        },
      },
      analytics: {
        trackingId: oAccessToken.trackingId
      },
      cart: {
        items: loadCartItemsFromLocalStorage() ?? []
      }
    },
  });
};


export const saveCartItemsToLocaleStorage = (cartState: CartState): void => {
  try {
    window.localStorage.setItem(
      'coveo-cartState',
      JSON.stringify(cartState.items)
    );
  } catch (err) {
    console.error('Failed to save cart items to local storage', err);
  }
};

export const loadCartItemsFromLocalStorage = (): CartItemWithMetadata[] | null => {
  try {
    const cartItems = window.localStorage.getItem('coveo-cartState');
    return cartItems ? JSON.parse(cartItems) as CartItemWithMetadata[] : null;
  } catch (err) {
    console.error('Failed to load cart items from local storage', err);
    return null;
  }
};

export const getCookieValue = (name: string): string => {
  return document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || '';
};
